import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const LegacyRedirect = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (slug) {
      // Ambil SKU (misal: m049900) dari depan slug
      const detectedSku = slug.split('-')[0];
      if (detectedSku.length >= 3) {
        navigate(`/product/${detectedSku}`, { replace: true });
      } else {
        navigate("/", { replace: true });
      }
    }
  }, [slug, navigate]);

  return null;
};

export default LegacyRedirect;